import { getLanguageDirection } from "../core/i18n/config";
import { useTranslation } from "./useTranslation";
export function useLanguageDirection() {
    const { language } = useTranslation();
    return getLanguageDirection(language);
}
